import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    color: theme.palette.errorColor,
    marginTop: 20,
  },
})

const FormError = ({ classes, className, text }) => {
  return <span className={classNames(classes.root, className)}>{text}</span>
}

FormError.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  text: PropTypes.string,
}

export default withStyles(styles)(FormError)



// WEBPACK FOOTER //
// ./src/components/atoms/FormError.js